import { render, staticRenderFns } from "./InventorySummary.vue?vue&type=template&id=434a78db&"
import script from "./InventorySummary.vue?vue&type=script&lang=js&"
export * from "./InventorySummary.vue?vue&type=script&lang=js&"
import style0 from "./InventorySummary.vue?vue&type=style&index=0&id=434a78db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports